import { Form } from '@ant-design/compatible'

import ManageGoalForm from './ManageGoalForm'

export default Form.create({
  name: 'pumpingSystemForm',
})(ManageGoalForm)
